import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router'
import envs from '@/envs'
import _ from 'lodash'
import Cookies from 'js-cookie'
import localStore from '@/utils/localStore'
import Layout from '@/layout/layout.vue'
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);
// Nếu bạn muốn cấu hình mặc định toàn cục
Viewer.setDefaults({
  Options: { 
    inline: false, 
    button: true, 
    navbar: false, 
    title: false, 
    toolbar: true, 
    tooltip: true, 
    movable: true, 
    zoomable: true, 
    rotatable: true, 
    scalable: true 
  }
});

import { getComCode } from '@/utils/token'
import { getRouterMenu, getUserMenu } from '@/api/system/menuManage' // 메뉴 api 호출
// Mr.Chien add more 2026.03.25
import '@/assets/css/tqm-common.css'
import '@/assets/css/mobile-table.css'
import MobileCardItem from '@/components/base/MobileCardItem.vue'
// Đăng ký toàn cục
Vue.component('mobile-card-item', MobileCardItem)

// vuescroll 추가
// import vuescroll from 'vue-scroll'
import './assets/icons' // icon
import svgicon from '@/components/svgicon' // svg component

//From PLM
// import "@/assets/css/default.css"
// import "@/assets/css/sub.css"
// import "@/assets/element-ui/index.css" // element ui 테마 css 적용

// Splitpanes
// import 'splitpanes/dist/splitpanes.css'

// 전체 화면 사용시 레이아웃 감추는 여부 설정
//store.dispatch('SetLayoutHideMode', target.layoutHideMode ? target.layoutHideMode : false)

//toastify
//import VueToastify from 'vue-toastify'

//vueToastify
/* Vue.use(VueToastify, {
  position: 'center-center',
  canTimeout: false,
  theme: 'light',
  iconEnabled: true,
  withBackdrop: true
}) */

// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)

// vueDaumPostcode
import VueDaumPostcode from 'vue-daum-postcode'
Vue.use(VueDaumPostcode, { scriptUrl: "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js" })

// draggable
import { Draggable } from 'draggable-vue-directive' 

Vue.use({
  install(Vue, options) {
    Vue.directive('draggable', Draggable)
  }
})
Vue.use(VueDaumPostcode)

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

//Devextreme
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import 'devexpress-diagram/dist/dx-diagram.css'

//Login Form
// import "@/assets/css/style-login-form.css"

//Devextreme Grid default setting
import '@/components/options/dxEnvs.js'

// Devextreme language settings
import { locale } from 'devextreme/localization'

// vuetify theme loading
import vuetify from '@/plugins/vuetify'
import qLoading from './plugins/qLoading'
import qMsgbox from './plugins/qMsgbox.js'
import Toast from "vue-toastification";
//import "vue-toastification/dist/index.css";
import "@/assets/css/win_style.css";
import vueMoment from 'vue-moment';

// Loading echart libraries and themes
import '@/assets/theme/echart/index.js'

Vue.use(vueMoment)
Vue.config.productionTip = false
Vue.use(qLoading); // Custom Loading
Vue.use(qMsgbox, {aa:Vue});
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 5,
  newestOnTop: true
});

Vue.component('svg-icon', svgicon) // register globally

// Global settings
Vue.prototype.$envs = envs
Vue.prototype.$Cookies = Cookies
Vue.prototype.$_ = _
Vue.prototype.$localStore = localStore
Vue.prototype.$EventBus = new Vue()

Vue.prototype.$gUtil = require('@/utils/common');

// i18n
import VueI18n from 'vue-i18n'
import messages from '@/i18n/custom'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages,     // set locale messages
})

let DynamicRouteInfo = [] //[Dynamic routing processing]

let vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  methods: {
    async getDynamicRoutes(list) {
      // getProgramData('')
      //Configure routing for all menus
      // await getRouterMenu({comCode: getComCode()})
        // .then(response => {
          // DynamicRouteInfo.push(dashboard)
          // console.log('getDynamicRoutes list',list)
          _.cloneDeep(list).forEach(route => {
            
            //if(route.paCode != null && route.pgCode != null)
            if(route.prtId != null && route.prtId != '' && route.pgmId != null && route.pgmId != '')
              this.createAndAppendRoute(route)
          })

          //init route
          let newRoute = {
            path: '/',
            redirect: '/pageNotFound',
            component: Layout,
            children: DynamicRouteInfo
          }

          this.$router.addRoutes([newRoute])

          
        // })
        // .catch(error => {
        //   console.log(error)
        // })
        // .finally(() => {})
    },
    createAndAppendRoute: route => {
      //if (route.name == 'dashboard') {
      // console.log('routePath: ', routePath)
      // let newRoute = {
      //   path: `/${route.menuCode}`,
      //   name: `${route.menuName}`,
      //   //component: () => import(`@/views${route.path}/${route.component}.vue`),
      //   component: () => import(`@/views/${route.moduleCode}/${route.paCode}/${route.pgCode}.vue`),
      //   // meta: { proc_cd: `${route.progCd}`, title: `${route.progNm}`, affix: `${route.affix}` == 'Y' ? true : false, svcType: route.svcType },
      //   meta: { menu_code: `${route.moduleCode}`, menu_id: `${route.menuCode}`, title: `${route.menuName}`, affix: false },
      //   // params: { proc_cd: `${route.progCd}`, title: `${route.progNm}`, affix: `${route.affix}` == 'Y' ? true : false }
      //   // query: route.name == 'dashboard' ? { tMenu: '1000', lvl: 0 } : undefined
      // }

      let newRoute;

      if(route.id === 'cmmcdmng' || route.id === 'mnmng' || route.id === 'mnauthmng') {
        newRoute = {
          path: `${route.pgmId}`,
          name: `${route.pgmId}`,
          component: () => import(`@/views${route.routerId}.vue`),
          meta: { menu_code: `${route.pgmId}`, menu_id: `${route.pgmId}`, title: `${route.ename}`, affix: false }
        }
      } else {
        newRoute = {
          path: `${route.pgmId}`,
          name: `${route.pgmId}`,
          component: () => import(`@/views/hip${route.routerId}.vue`),
          meta: { menu_code: `${route.pgmId}`, menu_id: `${route.pgmId}`, title: `${route.ename}`, affix: false }
        }
      }

      DynamicRouteInfo.push(newRoute)

      //this.$router.addRoutes([newRoute])
      // }
    }
  },
  beforeCreate() {
    // getRouterMenu({comCode: 'COM0001'})
    //     .then(response => {
    //       // list = response.list
    //       // console.log('beforeCreate list',response)
    //       this.getDynamicRoutes(response.list)
    // })

    // const param = {
    //   userId: store.state.user.userId,
    //   sysCd: store.state.system.sysCd,
    //   sysId: store.state.system.sysId
    // }
    // getUserMenu(param).then(res => {
    //   // console.log('res', res.list)
    //   const list = res.list
    //   this.getDynamicRoutes(list)
    // })
  },
  created() {
    // Devextreme 언어 설정(for 캘린더)
    locale(this.$i18n.locale)
  },
  render: h => h(App)
}).$mount('#app')
